<div class="container-header eu-display_flex justify-content-between action-header">
    <button type="button" class="emd-btn _color_nonessential" (click)="ngbActiveModal.close()">Voltar</button>

    <button type="button" class="emd-btn _color_primary" (click)="exportAsPDF()">Exportar</button>
</div>

<div #pdf_element class="container-fluid p-0 txt__color--black">
    <div class="header__wrapper stone__bg--green">
        <div class="row mx-0 txt__color--white">
            <div class="col-12 p-0 header__top">
                <div class="row mx-5 my-4">
                    <div class="col-6">
                        <h2 class="header__title">stone</h2>
                        <h3 class="header__subtitle">Proposta Comercial</h3>
                    </div>
                    <div class="col-6 d-flex justify-content-end header__date">
                        <p>{{ date | date: 'longDate' }}</p>
                    </div>
                </div>
            </div>
            <div class="col-12 p-0 header__bottom">
                <div class="row m-5">
                    <div class="col">
                        <h3 class="header__subtitle">
                            <span>{{ proposal ? proposal.trade_name : '' }}</span>
                        </h3>
                        <h4 class="mt-1">
                            <span>{{ proposal ? (proposal.cnpj | cnpj) : '' }}</span>
                        </h4>
                        <p class="mt-2 header__bottom--txt-1">Proposta com as condições comerciais personalizadas para o seu negócio.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    @if (proposal.offer_conditions && (proposal.offer_conditions.daily_paiment || proposal.offer_conditions.promo_stone)) {
        @if (proposal.offer_conditions.promo_stone) {
            <div class="promo-stone-container row justify-content-center mt-5">
                <img class="promo-tag" width="70px" alt="" src="assets/offers/promo-tag.svg" />
                <div class="promo-stone-card primary col-10">
                    <header class="promo-stone-header color-primary mb-3">
                        <span class="emd-text txt-20">Nos 2 primeiros meses</span>
                    </header>

                    <span class="emd-text txt-20">
                        O preço promocional é válido apenas para o mês de contratação e o subsequente.
                    </span>

                    <div class="row mt-5 mx-0">
                        <div class="col-10">
                            <h2 class="text-left txt-20--bold">Taxas nas transações com cartão</h2>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-10 d-flex justify-content-center">
                            <div class="table__container">
                                <app-proposal-mdr-table [mdr]="proposal.mdr" />
                            </div>
                        </div>
                    </div>

                    <div class="row mt-5 mx-0">
                        <div class="col-10">
                            <h2 class="text-left txt-20--bold">Taxas de antecipação</h2>
                        </div>

                        <div class="eu-display_flex eu-justify_center mt-4">
                            <div
                                [ngClass]="{
                                    'box-gray--active': proposal ? proposal.anticipation.enabled && !proposal.is_e_commerce : false,
                                }"
                                class="col-4 box-gray"
                            >
                                <p class="text-center txt-18 txt__color--gray">
                                    <strong>Antecipação Automática:</strong>
                                    <br />
                                    {{ proposal ? (proposal.anticipation.automatic.value | percent: '1.2-2') : 0 }}
                                    ao mês
                                </p>

                                <span *ngIf="proposal?.anticipation?.enabled && !proposal.is_e_commerce" class="active-label"> ATIVA </span>
                            </div>

                            <div class="col-4 ml-3 box-gray" *ngIf="offer_type === 'aluguel'">
                                <p class="text-center txt-18 txt__color--gray">
                                    <strong>Antecipação Pontual:</strong>
                                    <br />
                                    {{ proposal ? (proposal.anticipation.punctual.value | percent: '1.2-2') : 0 }}
                                    ao mês
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-5 mx-0 mb-4 justify-content-center">
                        <div class="col-10 eu-display_flex eu-justify_center">
                            <div class="col-10 info-tag">
                                <i class="fa fa-info-circle _color_subtle"></i>
                                <div class="eu-display_flex eu-column" style="gap: 0.25rem">
                                    <span class="emd-text _size-info">
                                        Promoção com taxas mais baratas nos 2 primeiros meses, sendo alteradas segundo o faturamento mensal
                                    </span>
                                    <span class="emd-text _size-info"> Recebimento no mesmo dia sujeito a análise. </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center mt-5">
                <div class="promo-stone-card col-10">
                    <header class="promo-stone-header color-default">
                        <span class="emd-text txt-20">A partir do 3º mês</span>
                    </header>

                    <div class="row mt-5 mx-0">
                        <div class="col-10">
                            <span class="emd-text txt-20"
                                >Meta acordada na contratação: {{ proposal ? (proposal.tpv | currency: 'BRL') : 0 }}</span
                            >
                            <h2 class="mt-4 text-left txt-20--bold">Taxas nas transações com cartão</h2>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-10 d-flex justify-content-center">
                            <div class="table__container">
                                <app-proposal-mdr-table
                                    [mdr]="proposal.mdr"
                                    [promoStoneFees]="promoStoneFees"
                                    [isPromoStoneConditions]="true"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="row mt-5 mx-0 mb-4">
                        <div class="col-10">
                            <h2 class="text-left txt-20--bold">Taxas de antecipação</h2>
                        </div>

                        <div class="eu-display_flex eu-justify_center mt-4 mb-4">
                            <div
                                [ngClass]="{
                                    'box-gray--active': proposal ? proposal.anticipation.enabled && !proposal.is_e_commerce : false,
                                }"
                                class="box-gray min-height-200"
                            >
                                <div class="eu-display_flex eu-column eu-justify_space-between w-100">
                                    <p class="text-center txt-18 txt__color--gray">
                                        <strong>Antecipação Automática:</strong>
                                    </p>

                                    <div class="eu-display_flex eu-justify_space-between">
                                        <span class="emd-text txt-18 _type_bold">Bateu Meta</span>
                                        <span class="txt-18">
                                            {{ proposal ? (promoStoneFees.hitGoal.rav / 100 | percent: '1.2-2') : 0 }}
                                            ao mês
                                        </span>
                                    </div>

                                    <hr />

                                    <div class="eu-display_flex eu-justify_space-between">
                                        <span class="emd-text txt-18 _type_bold">Não Bateu Meta</span>
                                        <span class="txt-18">
                                            {{ proposal ? (promoStoneFees.didntReachGoal.rav / 100 | percent: '1.2-2') : 0 }}
                                            ao mês
                                        </span>
                                    </div>
                                </div>

                                <span *ngIf="proposal?.anticipation?.enabled && !proposal.is_e_commerce" class="active-label promo-stone">
                                    ATIVA
                                </span>
                            </div>

                            <div class="ml-3 box-gray eu-display_flex eu-column eu-justify_start" *ngIf="offer_type === 'aluguel'">
                                <p class="text-center txt-18 txt__color--gray">
                                    <strong>Antecipação Pontual:</strong>
                                </p>
                                <div class="eu-display_flex eu-justify_center eu-align-items_center" style="height: 100%">
                                    <p class="text-center txt-18 txt__color--gray">
                                        {{ proposal ? (proposal.anticipation.punctual.value | percent: '1.2-2') : 0 }}
                                        ao mês
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        @if (proposal.offer_conditions.daily_paiment && !proposal.offer_conditions.promo_stone) {
            <div class="row mt-5" style="padding: 0.25rem 0.5rem">
                <div class="row mt-5 mx-0">
                    <div class="col-10">
                        <h2 class="text-left txt-20--bold">Taxas nas transações com cartão</h2>
                    </div>
                </div>

                <div class="mt-5 row justify-content-center">
                    <div class="col-10">
                        <span class="emd-text txt-20--bold">Receber No Mesmo Dia</span>
                    </div>

                    <div class="col-10 d-flex eu-column justify-content-center">
                        <div class="table__container">
                            @if (proposal.mdrD0) {
                                <app-proposal-mdr-table [isDailyPayment]="true" [mdr]="proposal.mdrD0" />
                            }
                        </div>
                    </div>
                </div>
                <div class="row mt-5 justify-content-center">
                    <div class="col-10">
                        <span class="emd-text txt-20--bold">Receber No Próximo Dia</span>
                    </div>

                    <div class="col-10 d-flex justify-content-center">
                        <div class="table__container">
                            @if (proposal.mdrD1) {
                                <app-proposal-mdr-table [mdr]="proposal.mdrD1" />
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
    } @else {
        <div class="row justify-content-center mt-5">
            <div class="col-10">
                <div *ngIf="offer_type === 'adesao'" class="plan-name eu-pb_2" style="text-align: left; text-transform: capitalize">
                    <h2>
                        {{ proposal.plan_name }}
                    </h2>
                </div>
                <h2 class="text-left txt-20--bold">Taxas nas transações com cartão</h2>
            </div>

            <app-proposal-mdr-table [mdr]="proposal.mdr" />
        </div>
    }

    <div class="row mx-0 mt-5 justify-content-center">
        <div class="col-10">
            <p *ngIf="!proposal?.anticipation?.enabled && !proposal.is_e_commerce" class="txt-20">
                <strong>
                    Recebimento das vendas feitas no débito em 1 dia útil, no crédito à vista em 30 dias e no crédito parcelado em 30 dias a
                    cada parcela.
                </strong>
                Você pode antecipar suas vendas no app ou na maquininha, através da antecipação pontual ou ativando a antecipação
                automática. Parcelamento a partir de 13x disponível apenas para cartões elegíveis para esta modalidade.
            </p>

            @if (!proposal.offer_conditions?.daily_paiment) {
                <p *ngIf="proposal?.anticipation?.enabled && !proposal.is_e_commerce" class="txt-20">
                    <strong>
                        Recebimento das vendas em 1 dia útil. <br />Vendas feitas no crédito à vista ou parcelado devem ser somadas à sua
                        taxa de antecipação
                    </strong>
                    , conforme o número de parcelas. Parcelamento a partir de 13x disponível apenas para cartões elegíveis para esta
                    modalidade.
                </p>
            } @else {
                <p class="txt-20">
                    <strong> Recebimento das vendas no mesmo dia sujeito a análise. </strong>
                </p>
                <p *ngIf="proposal?.anticipation?.enabled && !proposal.is_e_commerce" class="txt-20">
                    <strong> Vendas feitas no crédito à vista ou parcelado devem ser somadas à sua taxa de antecipação </strong>
                    , conforme o número de parcelas. Parcelamento a partir de 13x disponível apenas para cartões elegíveis para esta
                    modalidade.
                </p>
            }

            <p *ngIf="proposal.is_e_commerce && !proposal?.anticipation?.enabled && !proposal.ipv?.enabled" class="txt-20">
                <strong>
                    Recebimento das vendas feitas no crédito à vista em 30 dias e no crédito parcelado em 30 dias a cada parcela.
                </strong>
                Caso tenha interesse em realizar antecipação de recebíveis, entrar em contato com o seu Parceiro.
            </p>
        </div>
    </div>

    @if (!proposal.offer_conditions?.promo_stone) {
        <div class="row mt-5 mx-0 justify-content-center">
            <div class="col-10 mb-4">
                <h2 class="text-center txt-20--bold">Taxas de antecipação</h2>
            </div>

            <div
                [ngClass]="{
                    'box-gray--active': proposal ? proposal.anticipation.enabled && !proposal.is_e_commerce : false,
                }"
                class="col-4 box-gray"
            >
                <p class="text-center txt-18 txt__color--gray">
                    <strong>Antecipação Automática:</strong>
                    <br />
                    {{ proposal ? (proposal.anticipation.automatic.value | percent: '1.2-2') : 0 }}
                    ao mês
                </p>

                <span *ngIf="proposal?.anticipation?.enabled && !proposal.is_e_commerce" class="active-label"> ATIVA </span>
            </div>

            <div class="col-4 ml-3 box-gray" *ngIf="offer_type === 'aluguel'">
                <p class="text-center txt-18 txt__color--gray">
                    <strong>Antecipação Pontual:</strong>
                    <br />
                    {{ proposal ? (proposal.anticipation.punctual.value | percent: '1.2-2') : 0 }}
                    ao mês
                </p>
            </div>
        </div>
    }

    <div *ngIf="!proposal.is_e_commerce" class="row mt-5 mx-0 justify-content-center">
        <div class="col-10">
            <p class="txt-18">
                <strong> Vendas no Link de Pagamento via Conta Stone possuem condições diferentes. </strong>
                Verifique a disponibilidade da antecipação no seu Aplicativo Stone.
            </p>
        </div>
    </div>

    <div *ngIf="!proposal.is_e_commerce" class="row mt-5 mx-0 justify-content-center">
        <div class="col-10">
            <h2 class="text-center txt-20--bold">Taxas nas transações com Pix</h2>
        </div>

        <div class="col-4 mt-4 box-gray">
            <p class="text-center txt-18 txt__color--gray">
                <strong>Venda com Pix (QR Code):</strong>
                <br />
                {{ proposal ? (proposal.pix | percent: '1.2-2') : 0 }}
            </p>
        </div>

        <div class="col-10 mt-5">
            <p class="txt-18">
                <strong>Recebimento instantâneo</strong> das vendas feitas com Pix na Maquininha ou no Aplicativo. Transferência via Pix no
                Aplicativo.
            </p>
        </div>
    </div>

    <div class="row mt-5 mx-0 justify-content-center">
        <div class="col-10">
            <h2 class="text-center txt-20--bold">Condições comerciais</h2>
        </div>

        <div class="col-6 mt-4 box-gray">
            <p class="text-center txt-18 txt__color--gray">
                <strong>Faturamento mensal mínimo acordado:</strong>
                <br />
                <span class="line-height-2">{{ proposal ? (proposal.tpv | currency: 'BRL') : 0 }}</span>
                <br />
                <span class="line-height-08 txt-14">
                    em transações feitas em crédito e débito no cartão (na maquininha ou por Link de Pagamento) e PIX (direto na maquininha)
                </span>
            </p>
        </div>

        <div class="col-10 mt-5">
            <p class="txt-18">
                <span *ngIf="offer_type === 'aluguel'"
                    >Suas condições foram personalizadas levando em consideração o faturamento informado.</span
                >
                Para manter suas taxas, você deve manter o patamar de vendas alinhado a este número.
            </p>
            <p class="mt-2 txt-18">
                <strong>
                    Caso ocorram alterações significativas no seu faturamento, você será informado via e-mail sobre o reajuste de suas taxas
                </strong>
            </p>
        </div>
    </div>

    <div *ngIf="!proposal.is_e_commerce" class="row mt-5 mx-0 justify-content-center">
        <div class="col-10">
            <h2 *ngIf="proposal.ipv?.enabled" class="text-center txt-20--bold">Mensalidade com isenção por volume de vendas</h2>
            <h2 *ngIf="!proposal.ipv?.enabled" class="text-center txt-20--bold">
                <span *ngIf="offer_type === 'aluguel'"> Mensalidade dos terminais </span>
                <span *ngIf="offer_type === 'adesao'"> Valor de contratação </span>
            </h2>
        </div>

        <div *ngIf="proposal?.ipv?.enabled" class="col-6 mt-4 box-gray box-gray--active">
            <p class="text-center txt-18 txt__color--gray">
                <strong>Isenção por volume de vendas:</strong>
                <br />
                <span>Faturamento de {{ proposal.tpv | currency: 'BRL' }}</span>
            </p>
            <span class="active-label">ATIVA</span>
        </div>

        <div class="col-12 mt-5">
            <div class="row mt-2 mx-0 justify-content-center" style="gap: 1rem">
                <div class="eu-display_flex justify-content-center eu-wrap" style="gap: 1rem">
                    <div class="col-3 box-gray">
                        <p class="text-center txt__color--gray">
                            <strong
                                ><span *ngIf="offer_type === 'aluguel'"> Mensalidade total: </span>
                                <span *ngIf="offer_type === 'adesao'"> Valor total: </span></strong
                            >
                            <br />
                            <span *ngIf="offer_type === 'aluguel'">{{
                                proposal ? (proposal.ipv.monthly_total_billing | currency: 'BRL') : 0
                            }}</span>
                            <span *ngIf="offer_type === 'adesao'">{{
                                proposal ? (proposal.billing_total_value | currency: 'BRL') : 0
                            }}</span>
                        </p>
                    </div>

                    <div *ngIf="offer_type === 'aluguel' && !proposal.ipv.enabled" class="col-3 box-gray">
                        <p class="text-center txt__color--gray">
                            <strong>Isenção por:</strong>
                            <br />
                            <span>{{
                                proposal.exemption_months > 1
                                    ? proposal.exemption_months.toString() + ' meses'
                                    : proposal.exemption_months.toString() + ' mês'
                            }}</span>
                        </p>
                    </div>

                    <div *ngIf="offer_type === 'adesao' || proposal.ipv.enabled" class="box-gray col-3">
                        <p class="text-center txt__color--gray">
                            <strong>Máquinas:</strong>
                            <br />
                            <span>{{ proposal ? proposal.ipv.terminal_amount : '' }}</span>
                        </p>
                    </div>
                </div>

                <div *ngIf="offer_type === 'aluguel' && !proposal.ipv.enabled" class="box-gray col-6">
                    <p class="text-center txt__color--gray">
                        <strong>Máquinas:</strong>
                        <br />
                        <span>{{ proposal ? proposal.ipv.terminal_amount : '' }}</span>
                    </p>
                </div>
            </div>
        </div>

        <div *ngIf="!proposal?.ipv?.enabled" class="col-10 mt-5">
            <p *ngIf="offer_type === 'adesao'" class="txt-18">
                <strong
                    >O valor da contratação varia conforme a quantidade e a tecnologia da máquina selecionada. O pagamento pode ser feito em
                    até 12x. </strong
                >O comodato é um tipo de empréstimo: você usa a maquininha e todos os seus benefícios enquanto tiver o plano. Cancelando o
                plano, você devolve a maquininha para a Stone.
            </p>
            <p class="txt-18" *ngIf="offer_type === 'aluguel'">
                A mensalidade será cobrada todo o inicio do mês através da agenda de recebível. Esta mensalidade entrará em vigor após o seu
                <strong>período promocional.</strong>
            </p>
        </div>

        <div *ngIf="proposal?.ipv?.enabled" class="col-12">
            <div class="row mx-0 mt-5 justify-content-center">
                <div class="col-10">
                    <p class="txt-18">
                        <strong> O valor da sua mensalidade poderá ser isento de acordo com o seu faturamento.<br /> </strong>
                        No cálculo do seu faturamento contam as vendas feitas em crédito e débito no cartão (na maquininha ou por link de
                        pagamento via Conta Stone) e no Pix (direto na maquininha).
                    </p>
                </div>

                <div class="col-10 mt-5">
                    <h3 class="text-center txt-18--bold">Você pode consultar os patamares de isenção abaixo:</h3>
                </div>

                <div class="col-10 mt-4">
                    <div class="row mx-0 justify-content-center">
                        <div class="col-8 ipv-table-box">
                            @if (proposal.offer_conditions?.promo_stone) {
                                <table class="ipv-table">
                                    <thead>
                                        <th class="ipv-table-th">Total de Vendas</th>
                                        <th class="ipv-table-th">Isenção</th>
                                    </thead>

                                    <tbody>
                                        <tr class="ipv-table-row">
                                            <td class="ipv-table-td">R$ 0 a R$ 29 mil</td>
                                            <td class="ipv-table-td">0 máquinas</td>
                                        </tr>

                                        <tr class="ipv-table-row">
                                            <td class="ipv-table-td">R$ 30 mil a R$ 49 mil</td>
                                            <td class="ipv-table-td">2 máquinas</td>
                                        </tr>

                                        <tr class="ipv-table-row">
                                            <td class="ipv-table-td">R$ 50 mil a R$ 99 mil</td>
                                            <td class="ipv-table-td">4 máquinas</td>
                                        </tr>

                                        <tr class="ipv-table-row">
                                            <td class="ipv-table-td">+ R$ 100 mil</td>
                                            <td class="ipv-table-td">
                                                6 máquinas
                                                <br />
                                                +2 máquinas a
                                                <br />
                                                cada R$ 50 mil
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            } @else {
                                <table class="ipv-table">
                                    <thead>
                                        <th class="ipv-table-th">Total de Vendas</th>
                                        <th class="ipv-table-th">Antecipação</th>
                                        <th class="ipv-table-th">Isenção</th>
                                    </thead>

                                    <tbody>
                                        <tr class="ipv-table-row">
                                            <td class="ipv-table-td">R$ 0 a R$ 9 mil</td>
                                            <td class="ipv-table-td">-</td>
                                            <td class="ipv-table-td">0 máquinas</td>
                                        </tr>

                                        <tr class="ipv-table-row">
                                            <td class="ipv-table-td">R$ 10 mil a R$ 19 mil</td>
                                            <td class="ipv-table-td">Obrigatória</td>
                                            <td class="ipv-table-td">1 máquina</td>
                                        </tr>

                                        <tr class="ipv-table-row">
                                            <td class="ipv-table-td">R$ 20 mil a R$ 29 mil</td>
                                            <td class="ipv-table-td">Opcional</td>
                                            <td class="ipv-table-td">1 máquina</td>
                                        </tr>

                                        <tr class="ipv-table-row">
                                            <td class="ipv-table-td">R$ 30 mil a R$ 49 mil</td>
                                            <td class="ipv-table-td">Opcional</td>
                                            <td class="ipv-table-td">2 máquinas</td>
                                        </tr>

                                        <tr class="ipv-table-row">
                                            <td class="ipv-table-td">R$ 50 mil a R$ 99 mil</td>
                                            <td class="ipv-table-td">Opcional</td>
                                            <td class="ipv-table-td">4 máquinas</td>
                                        </tr>

                                        <tr class="ipv-table-row">
                                            <td class="ipv-table-td">+ R$ 100 mil</td>
                                            <td class="ipv-table-td">Opcional</td>
                                            <td class="ipv-table-td">
                                                6 máquinas
                                                <br />
                                                +2 máquinas a
                                                <br />
                                                cada R$ 50 mil
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-5 mx-0 justify-content-center footer txt__color--white">
        <div class="col-10 d-flex flex-column justify-content-center px-4 footer-top">
            <h2 class="h1">Vamos em Frente ?</h2>
            <p class="txt-20">Oferta válida por <strong>1 dia.</strong></p>
            <span *ngIf="offer_type !== 'adesao'" class="txt-18">ID da proposta {{ proposal ? proposal.proposal_id : '' }}</span>
        </div>
        <div class="col-12 footer-bottom">
            <div class="row justify-content-center h-100">
                <div class="col-10 px-4 d-flex justify-content-between align-items-center">
                    <span class="txt-18">{{ date | date: 'longDate' }}</span>
                    <span class="h1">stone</span>
                </div>
            </div>
        </div>
    </div>
</div>
